import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=0f557833&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=0f557833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f557833",
  null
  
)

export default component.exports